import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#profesoara", label: "Profesoara" },
  { href: "#despre", label: "Despre" },
  { href: "#cursuri", label: "Cursuri & Prețuri" },
  { href: "#program", label: "Program" },
  { href: "#scoli", label: "Pentru Școli" },
  { href: "#comunitate", label: "Comunitate" },
  { href: "#contact", label: "Contact" },
];

export const scrollToId = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-[background-color,box-shadow,border-color] duration-500 border-b ${
        scrolled ? "bg-washi/85 backdrop-blur-md border-border" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 sm:h-[72px] flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand-logo"
          onClick={(e) => go(e, "#top")}
          className="flex items-center gap-3 group"
        >
          <img src="/sora-logo.png" alt="SORA" className="h-9 w-auto transition-transform duration-500 group-hover:rotate-[-8deg]" />
          <span className="font-mono font-bold tracking-[0.35em] text-sm text-sumi">SORA</span>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              onClick={(e) => go(e, l.href)}
              className="text-sm font-medium text-charcoal/80 hover:text-hanko transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#lectie"
            data-testid="nav-cta-trial"
            onClick={(e) => go(e, "#lectie")}
            className="ml-2 bg-hanko text-washi text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-hankodeep transition-colors duration-300"
          >
            Lecție gratuită
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden w-11 h-11 flex items-center justify-center text-sumi"
          aria-label="Meniu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="md:hidden bg-washi/95 backdrop-blur-md border-t border-border px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              onClick={(e) => go(e, l.href)}
              className="text-lg font-serif text-sumi"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#lectie"
            data-testid="nav-mobile-cta-trial"
            onClick={(e) => go(e, "#lectie")}
            className="mt-2 bg-hanko text-washi text-center font-semibold px-5 py-3.5 rounded-full"
          >
            Programează o lecție gratuită
          </a>
        </nav>
      )}
    </header>
  );
}
